import axios from 'axios'
import { extractError } from '../utils/errorHandler'

export const sendPrintedLabel = async (payload) => {
  try {
    await axios.post('print/label', payload)
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}


